<div class="account-center-banner">
  <div class="account-center-banner__content">
    <ng-container *ngFor="let title of bannerTitles">
      <div class="account-center-banner__title">
        {{ title }}
      </div>
    </ng-container>

    <ng-container *ngFor="let subTitle of bannerSubTitles">
      <div class="account-center-banner__subtitle">
        {{ subTitle }}
      </div>
    </ng-container>
    <div *ngIf="buttonText" class="account-center-banner__button-container">
      <button
        cp-button
        theme="blue-light"
        size="large"
        *ngIf="!loadingEsign; else esign"
        (click)="onSingleClickAction($event)"
      >
        {{ buttonText }}
      </button>

      <ng-template #esign><spinner color="white"></spinner></ng-template>
    </div>
  </div>
</div>
